const rapidocApiRequestStyles = `
    .req-res-title + div > div { 
        display: block !important;
    }

    .req-res-title + div > div .m-btn {
        margin-bottom: 0.75rem !important; 
        margin-top: 0.75rem !important;
    }

    input[type="file"] {
        border-color: #a0a4a8 !important;
        transition: border-color .15s !important;
    }

    input[type="file"]:hover {
        border-color: #303faf;
    }

    .request-body-container ~ .row,
    .request-body-container ~ .row + .tab-panel {
        display: block !important;
    }

    .request-panel .gray-text {
        word-break: break-all !important;
    }
`;

export default rapidocApiRequestStyles;
